import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { useLoggedOutSuppliersPageIsPending } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { useLoggedOutSuppliersPageRecordAndTrackAnalytics } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/useLoggedOutSuppliersPageRecordAndTrackAnalytics";
import { useLoggedOutSuppliersPageAnalyticsTracking } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/useLoggedOutSuppliersPageAnalyticsTracking";
import { useEffect } from "react";

export const LoggedOutSuppliersPageEffects = () => {
  useLoggedOutSuppliersPageAnalyticsTracking();
  useLoggedOutSuppliersPageRecordAndTrackAnalytics();

  const isPending = useLoggedOutSuppliersPageIsPending();
  useEffect(() => {
    if (!isPending) {
      PageInitialized.publish();
    }
  }, [isPending]);

  return null;
};
